export default __webpack_public_path__ + "static/media/thumb05_letter2@2x.ccccb60b.png";